<template>
    <span class="text-danger" v-if="mostrarBtnDesassociarEntrega">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Desassociar Entrega"
            @click.stop="
                confirmarDesassociarEntrega(
                    finalizacaoEntrega.finalizacaoEntregaId
                )
            "
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => ({})
        },

        finalizacaoEntrega: {
            type: Object,
            default: () => ({})
        },

        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDesassociarEntrega(finalizacaoEntregaId) {
            this.$swal({
                title: 'Desassociação de Entrega',
                html: `Confirma a desassociação da entrega?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociarEntrega(finalizacaoEntregaId)
                }
            })
        },

        desassociarEntrega(finalizacaoEntregaId) {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .desassociarEntrega({
                    finalizacaoId: this.$route.params.finalizacaoId,
                    finalizacaoEntregaId: finalizacaoEntregaId
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterFinalizacaoAtualizada')
                        } else {
                            this.$toast.error(
                                'Erro ao desassociar entrega da finalização.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnDesassociarEntrega() {
            return (
                (this.finalizacao.status === 0 ||
                    this.finalizacao.status === 5) &&
                this.$temAcesso('CRED-FORN-FIN-03')
            )
        }
    }
}
</script>
